import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as VisaIcon } from 'src/assets/svg/visa1.svg';
import { ReactComponent as MastercardIcon } from 'src/assets/svg/mastercard.svg';
import { ReactComponent as GroupIcon } from 'src/assets/svg/group.svg';

import { styles } from './styles';

export const PaymentOptionBanner: FC<{ showPaymentOptions?: boolean }> = ({
    showPaymentOptions = false,
}) => {
    const { t } = useTranslation();

    return (
        <Box css={styles.container}>
            {showPaymentOptions && (
                <Typography variant="body4" css={styles.optionText}>
                    {t('payment_option_info')}
                </Typography>
            )}
            <Box css={showPaymentOptions ? styles.paymentIconsWithSideText : styles.iconsWrapper}>
                <VisaIcon css={styles.icon1} />
                <MastercardIcon css={styles.icon2} />
                <GroupIcon css={styles.icon3} />
            </Box>
        </Box>
    );
};
